import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { NewsArticle, ReviewNewsArticle } from "schema-dts";

import { useArticleSchemaContext } from "~/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "~/components/article/article-schema/types";

type Props = Record<string, never>;

export const ReviewNewsArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<NewsArticle, ReviewNewsArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["NewsArticle", "ReviewNewsArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

ReviewNewsArticleSchema.displayName = "ReviewNewsArticleSchema";
